import { addNewRound, updateNewRound } from 'modules/ATS/action.js'
import selectors from 'modules/ATS/selector.js'
import { connect } from 'react-redux'
import JobRoles from '..'
import {
  exportCandidate,
  getCorporateData,
  getDegreeList,
  getDepartmentList,
  getDomainList,
  getExportFiledData,
  getJobRoleList,
  getRoleFilter,
  getScheduleFilter,
  getStatusFilter,
  getYear,
  getInstituteData,
  getEligibilityCriteriaQualification,
  exportCSV,
  duplicateRole,
  archiveJobRole,
  unarchiveJobRole,
} from '../actions'
import { getJobCategory } from 'modules/JobRoles/NewJobRole/actions.js'
const mapStateToProps = state => ({
  roundData: selectors.getRoundData(state),
  updateRoundData: selectors.updatedRoundData(state),
  instituteCampusId: state.auth.instituteDetails.id,
})

const mapDispatchToProps = {
  getJobRoleList,
  getCorporateData,
  getInstituteData,
  addNewRound,
  updateNewRound,
  exportCandidate,
  getExportFiledData,
  getDepartmentList,
  getDegreeList,
  getDomainList,
  getRoleFilter,
  getStatusFilter,
  getScheduleFilter,
  getYear,
  getEligibilityCriteriaQualification,
  exportCSV,
  getJobCategory,
  duplicateRole,
  archiveJobRole,
  unarchiveJobRole,
}

export default connect(mapStateToProps, mapDispatchToProps)(JobRoles)
